module.exports = __webpack_public_path__ + "static/media/error.ad30fb3b.svg";